// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRecurringContributionPatchUpdateRequestDto
 */
export interface IRecurringContributionPatchUpdateRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IRecurringContributionPatchUpdateRequestDto
     */
    status: IRecurringContributionPatchUpdateRequestDtoStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum IRecurringContributionPatchUpdateRequestDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    PAUSED = 'PAUSED',
    CANCELLED = 'CANCELLED',
    EXPIRED = 'EXPIRED'
}


/**
 * Check if a given object implements the IRecurringContributionPatchUpdateRequestDto interface.
 */
export function instanceOfIRecurringContributionPatchUpdateRequestDto(value: object): value is IRecurringContributionPatchUpdateRequestDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function IRecurringContributionPatchUpdateRequestDtoFromJSON(json: any): IRecurringContributionPatchUpdateRequestDto {
    return IRecurringContributionPatchUpdateRequestDtoFromJSONTyped(json, false);
}

export function IRecurringContributionPatchUpdateRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRecurringContributionPatchUpdateRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function IRecurringContributionPatchUpdateRequestDtoToJSON(json: any): IRecurringContributionPatchUpdateRequestDto {
    return IRecurringContributionPatchUpdateRequestDtoToJSONTyped(json, false);
}

export function IRecurringContributionPatchUpdateRequestDtoToJSONTyped(value?: IRecurringContributionPatchUpdateRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
    };
}

